import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagDk = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-dk",
	viewBox: "0 0 640 480",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#c8102e",
			d: "M0 0h640.1v480H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M205.7 0h68.6v480h-68.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 205.7h640.1v68.6H0z"
		})
	]
});
export default SvgFlagDk;
